import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWrite: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="write, edit-list, list"><path d="M21.25 11.7635L17.2365 7.75L7.75 17.2365V21.25H11.7635L21.25 11.7635Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 3.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 7.75H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 11.75H7.2522" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWrite;
